export default "__VITE_PUBLIC_ASSET__f7dd4755__"